// extracted by mini-css-extract-plugin
export var searchHeader = "_2q-0";
export var searchHeaderDark = "_2q-1";